import React from 'react';

import ButtonWithIcon from 'components/Buttons/ButtonWithIcon';
import { useSelector } from 'react-redux';
import { fnGetNextAvailableGuestLookupId } from '../redux/guestHelpers';
import { selectAllEventsInCart } from '../redux/selectors';

const AddUnnamedGuest = ({ fnHandleChosenConstituent }) => {
  const { firstName, lastName } = useSelector((state) => state.Checkout);
  const aEventsInCart = useSelector(selectAllEventsInCart);

  return (
    <ButtonWithIcon
      sIcon='plus'
      fnHandleClick={() => {
        const sGuestLookupId = fnGetNextAvailableGuestLookupId(aEventsInCart);
        const sGuestName =
          firstName && lastName
            ? `Guest ${sGuestLookupId} of ${firstName} ${lastName}`
            : `Guest ${sGuestLookupId}`;
        fnHandleChosenConstituent({
          FIRST_NAME: '',
          LAST_NAME: '',
          NAME: sGuestName,
          EMAIL_ADDRESS: '',
          LOOKUPID: sGuestLookupId,
        });
      }}
      sCypressId='add-unnamed-guest-button'
    >
      Add Unnamed Guest
    </ButtonWithIcon>
  );
};

export default AddUnnamedGuest;
